import * as React from "react";
import cx from "classnames";
import { HashLink as Link } from "react-router-hash-link";

import "./Panel.css";

const createHashHref = ({ nextSectionId }: PanelProps) => `/#${nextSectionId}`;

interface PanelProps {
  nextSectionId?: string; // ID of next section to scroll/nav to
  className?: string;
  children: React.ReactChild | React.ReactChild[];
}

const Panel = (props: PanelProps) => (
  <section className={cx("panel", props.className)}>
    <div className="panel__container container">{props.children}</div>
    {props.nextSectionId && (
      <div className="panel__scroll-container" id={props.nextSectionId}>
        <Link className="panel__scroll-link" to={createHashHref(props)} replace>
          <i className="fa fa-angle-double-down" />
        </Link>
      </div>
    )}
  </section>
);

export default Panel;



// WEBPACK FOOTER //
// ./src/routes/LandingPage/components/Panel.tsx